export function isSkuMapRestricted(discountDisplay?: string | null): discountDisplay is undefined | null | '' {
    return !discountDisplay?.trim();
}
